(function () {
  'use strict';
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var R = window.themeRoutes || { root: '/', cart: '/cart', cartAdd: '/cart/add', currency: 'INR' };
  var root = document.documentElement;
  var reduce = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  var fine = !!(window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches);
  var coarse = !!(window.matchMedia && window.matchMedia('(hover: none) and (pointer: coarse)').matches);
  var wide = function () { return window.matchMedia && window.matchMedia('(min-width: 900px)').matches; };
  function clamp(n, a, b) { return Math.min(b, Math.max(a, n)); }
  function buzz(ms) { if (coarse && navigator.vibrate) { try { navigator.vibrate(ms); } catch (e) {} } }

  /* ---------- little burst effects: confetti, hearts, sparkles ---------- */
  var STAR = '<svg viewBox="0 0 24 24" fill="currentColor"><path d="M12 0c.9 6.6 4.8 10.5 12 12-7.2 1.5-11.1 5.4-12 12-.9-6.6-4.8-10.5-12-12C7.2 10.5 11.1 6.6 12 0Z"/></svg>';
  var HEART = '<svg viewBox="0 0 24 24" fill="currentColor"><path d="M12 21s-8-5.2-8-11a4.6 4.6 0 0 1 8-3 4.6 4.6 0 0 1 8 3c0 5.8-8 11-8 11Z"/></svg>';
  function burst(x, y, kind, n) {
    if (reduce || !document.body.animate) return;
    var cs = getComputedStyle(root);
    var pal = [cs.getPropertyValue('--accent'), cs.getPropertyValue('--stone'), cs.getPropertyValue('--ink'), cs.getPropertyValue('--olive')];
    if (kind === 'confetti') pal.push(cs.getPropertyValue('--sale'));
    for (var i = 0; i < n; i++) {
      var el = document.createElement('span');
      el.className = 'fx';
      var size = kind === 'spark' ? 10 + Math.random() * 10 : 12 + Math.random() * 14;
      el.style.width = el.style.height = size + 'px';
      el.style.color = kind === 'heart' ? pal[0] : pal[i % pal.length];
      el.innerHTML = kind === 'heart' ? HEART : (kind === 'confetti' && i % 2 ? '<svg viewBox="0 0 10 10"><rect width="10" height="10" rx="2" fill="currentColor"/></svg>' : STAR);
      document.body.appendChild(el);
      var ang = kind === 'heart' ? -Math.PI / 2 + (Math.random() - 0.5) * 1.6 : Math.random() * Math.PI * 2;
      var dist = (kind === 'spark' ? 28 : 70) + Math.random() * (kind === 'spark' ? 34 : 90);
      var dx = Math.cos(ang) * dist, dy = Math.sin(ang) * dist + (kind === 'confetti' ? 50 : 0);
      var rot = (Math.random() - 0.5) * 540;
      var a = el.animate([
        { transform: 'translate(' + x + 'px,' + y + 'px) translate(-50%,-50%) scale(.2) rotate(0deg)', opacity: 1 },
        { transform: 'translate(' + (x + dx) + 'px,' + (y + dy) + 'px) translate(-50%,-50%) scale(1) rotate(' + rot + 'deg)', opacity: 1, offset: 0.6 },
        { transform: 'translate(' + (x + dx * 1.15) + 'px,' + (y + dy * 1.15 + 24) + 'px) translate(-50%,-50%) scale(.6) rotate(' + rot * 1.3 + 'deg)', opacity: 0 }
      ], { duration: kind === 'spark' ? 650 : 1000 + Math.random() * 400, easing: 'cubic-bezier(.2,.7,.3,1)' });
      a.onfinish = (function (e) { return function () { e.remove(); }; })(el);
    }
  }
  function burstAt(el, kind, n) {
    var r = el.getBoundingClientRect();
    burst(r.left + r.width / 2, r.top + r.height / 2, kind, n);
  }

  window.__ttReady = true;
  if (window.__ttFallback) clearTimeout(window.__ttFallback);
  if (reduce || !('IntersectionObserver' in window)) root.classList.add('no-reveal');

  /* ---------- scroll reveals ---------- */
  var io = null;
  function initReveal(scope) {
    var els = $$('[data-reveal]:not(.is-in)', scope || document);
    if (root.classList.contains('no-reveal')) { els.forEach(function (el) { el.classList.add('is-in'); }); return; }
    if (!io) {
      io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });
    }
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------- pinned panels ---------- */
  function setupStacks() {
    $$('[data-stack]').forEach(function (el) {
      var w = el.closest('.shopify-section');
      if (w) w.classList.add('is-stack');
    });
    var hw = $('[data-header]');
    hw = hw && hw.closest('.shopify-section');
    if (hw) hw.classList.add('is-header-wrap');
    fixStacks();
  }
  // A pinned panel taller than the screen must scroll until its bottom edge is visible, then pin.
  function fixStacks() {
    var vh = window.innerHeight;
    $$('.shopify-section.is-stack').forEach(function (w) { w.style.top = Math.min(0, vh - w.offsetHeight) + 'px'; });
  }

  /* ---------- hover jiggle on the hero letters ---------- */
  function initJiggle() {
    if (reduce) return;
    $$('[data-jiggle]:not([data-split])').forEach(function (h) {
      h.setAttribute('data-split', '1');
      var ls = $$('.line', h);
      h.setAttribute('aria-label', ls.length ? ls.map(function (l) { return l.textContent.trim(); }).join(' ') : h.textContent.replace(/\s+/g, ' ').trim());
      $$('.line > span, .rise > span', h).forEach(function (span) {
        var text = span.textContent;
        span.textContent = '';
        span.setAttribute('aria-hidden', 'true');
        for (var i = 0; i < text.length; i++) {
          var c = document.createElement('span');
          c.className = 'ch';
          c.textContent = text.charAt(i);
          c.style.setProperty('--r', (Math.random() * 16 - 8).toFixed(1) + 'deg');
          span.appendChild(c);
        }
      });
      var wobble = function (c) {
        if (!c || c.classList.contains('wob')) return;
        c.style.setProperty('--r', (Math.random() * 20 - 10).toFixed(1) + 'deg');
        c.classList.add('wob');
        setTimeout(function () { c.classList.remove('wob'); }, 720);
      };
      h.addEventListener('mouseover', function (e) { wobble(e.target.closest && e.target.closest('.ch')); });
      if (coarse) {
        // phones: drag a finger across the letters
        var touchWobble = function (e) {
          var t = document.elementFromPoint(e.clientX, e.clientY);
          wobble(t && t.closest && t.closest('.ch'));
        };
        h.addEventListener('pointerdown', touchWobble);
        h.addEventListener('pointermove', touchWobble);
      }
    });
  }

  /* ---------- draggable rail with arrows and progress ---------- */
  function initRails() {
    $$('[data-rail-wrap]:not([data-ready])').forEach(function (wrap) {
      wrap.setAttribute('data-ready', '1');
      var rail = $('[data-rail]', wrap), bar = $('[data-rail-bar]', wrap);
      if (!rail) return;
      var section = wrap.closest('section') || wrap;
      var prog = function () {
        var max = rail.scrollWidth - rail.clientWidth;
        var ratio = max > 0 ? rail.scrollLeft / max : 0;
        var w = bar ? bar.parentNode.clientWidth * 0.3 : 0;
        if (bar) bar.style.setProperty('--rx', (ratio * (bar.parentNode.clientWidth - w) / Math.max(w, 1) * 100).toFixed(1) + '%');
      };
      rail.addEventListener('scroll', prog, { passive: true });
      window.addEventListener('resize', prog);
      prog();
      var step = function (dir) { rail.scrollBy({ left: dir * Math.max(280, rail.clientWidth * 0.6), behavior: reduce ? 'auto' : 'smooth' }); };
      var prev = $('[data-rail-prev]', section), next = $('[data-rail-next]', section);
      if (prev) prev.addEventListener('click', function () { step(-1); });
      if (next) next.addEventListener('click', function () { step(1); });
      if (!fine) return;
      var down = false, sx = 0, sl = 0, moved = 0;
      rail.addEventListener('pointerdown', function (e) {
        if (e.pointerType !== 'mouse' || e.button !== 0) return;
        down = true; moved = 0; sx = e.clientX; sl = rail.scrollLeft;
      });
      window.addEventListener('pointermove', function (e) {
        if (!down) return;
        var dx = e.clientX - sx; moved = Math.max(moved, Math.abs(dx));
        if (moved > 6) rail.classList.add('is-drag');
        rail.scrollLeft = sl - dx;
      });
      var up = function () {
        if (!down) return;
        down = false;
        if (!rail.classList.contains('is-drag')) return;
        // let the click that follows a drag pass before links work again
        setTimeout(function () { rail.classList.remove('is-drag'); }, 30);
      };
      window.addEventListener('pointerup', up);
      window.addEventListener('pointercancel', up);
    });
  }

  /* ---------- scrolling text bands: drift, and lean into the scroll ---------- */
  var bands = [], swings = [];
  function initMarquee() {
    swings = $$('[data-swing]').map(function (el) { return { el: el, a: 0, v: 0 }; });
    swings.forEach(function (w) {
      if (fine) w.el.parentNode.addEventListener('mouseenter', function () { w.v += 3.2; });
      if (!coarse || w.el.__bound) return;
      w.el.__bound = true;
      var sx = 0, sy = 0, moved = 0, last = 0;
      var pivot = function () {
        var pr = w.el.parentNode.getBoundingClientRect();
        return { x: pr.left + w.el.offsetLeft + w.el.offsetWidth / 2, y: pr.top + w.el.offsetTop };
      };
      var aim = function (e) {
        var p = pivot();
        return clamp(-Math.atan2(e.clientX - p.x, Math.max(20, e.clientY - p.y)) * 180 / Math.PI, -70, 70);
      };
      w.el.addEventListener('pointerdown', function (e) {
        w.held = true; moved = 0; sx = e.clientX; sy = e.clientY; last = w.a;
        w.el.classList.add('is-used');
        try { w.el.setPointerCapture(e.pointerId); } catch (err) {}
        buzz(8);
      });
      w.el.addEventListener('pointermove', function (e) {
        if (!w.held) return;
        moved = Math.max(moved, Math.abs(e.clientX - sx) + Math.abs(e.clientY - sy));
        var a = aim(e);
        w.v = (a - last) * 0.6; last = a; w.a = a;
        w.el.style.setProperty('--sw', a.toFixed(2) + 'deg');
      });
      var release = function () {
        if (!w.held) return;
        w.held = false;
        if (moved < 8) { w.v += 9; var r = w.el.getBoundingClientRect(); burst(r.left + r.width / 2, r.top + r.height / 2, 'spark', 6); buzz(12); }
        else buzz(10);
      };
      w.el.addEventListener('pointerup', release);
      w.el.addEventListener('pointercancel', release);
    });
    bands = $$('[data-marquee]').map(function (el) {
      var track = $('.mq-track', el), set = $('.mq-set', el);
      return { el: el, track: track, set: set, dir: parseFloat(el.getAttribute('data-dir')) || -1, speed: parseFloat(el.getAttribute('data-speed')) || 1, flat: el.hasAttribute('data-flat'), paused: false, x: 0, vis: true };
    });
    if (reduce) return;
    if (!bands.length && !swings.length) return;
    bands.forEach(function (b) {
      b.el.classList.add('is-js');
      if (b.flat) {
        b.el.addEventListener('mouseenter', function () { b.paused = true; });
        b.el.addEventListener('mouseleave', function () { b.paused = false; });
      }
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (en) { b.vis = en[0].isIntersecting; }).observe(b.el);
      }
    });
    if (!initMarquee.running) { initMarquee.running = true; window.requestAnimationFrame(tick); }
  }
  var lastY = window.pageYOffset || 0, vel = 0;
  function tick() {
    var y = window.pageYOffset || 0;
    vel += ((y - lastY) - vel) * 0.18;
    lastY = y;
    var sk = clamp(vel * -0.35, -9, 9);
    bands.forEach(function (b) {
      if (!b.vis || !b.set) return;
      var w = b.set.offsetWidth;
      if (!w) return;
      if (b.paused) return;
      b.x += b.flat ? b.dir * 0.55 * b.speed * 1.6 : b.dir * (0.7 + Math.min(Math.abs(vel) * 0.2, 12));
      // wrap so the band never runs out
      if (b.x <= -w) b.x += w;
      if (b.x > 0) b.x -= w;
      b.track.style.transform = 'translate3d(' + b.x.toFixed(2) + 'px,0,0)' + (b.flat ? '' : ' skewX(' + sk.toFixed(2) + 'deg)');
    });
    swings.forEach(function (w) {
      if (w.held) return;
      // a pendulum: scrolling shoves it, a spring pulls it back
      w.v += -w.a * 0.07 + clamp(vel, -40, 40) * 0.035;
      w.v *= 0.93;
      w.a = clamp(w.a + w.v, -60, 60);
      w.el.style.setProperty('--sw', w.a.toFixed(2) + 'deg');
    });
    window.requestAnimationFrame(tick);
  }

  /* ---------- header, pinned panels, parallax, zipper, product scroll effects ---------- */
  var ticking = false;
  var pdp = null, shots = [], buyRow = null, buybar = null, progress = null, countEl = null;

  function update() {
    ticking = false;
    var y = window.pageYOffset || document.documentElement.scrollTop || 0;
    var vh = window.innerHeight;
    var header = $('[data-header]');
    if (header) header.classList.toggle('is-compact', y > 16);
    if (progress) {
      var maxY = Math.max(1, document.documentElement.scrollHeight - vh);
      progress.style.setProperty('--sp', clamp(y / maxY, 0, 1).toFixed(4));
    }
    if (reduce) return;

    $$('[data-stack]').forEach(function (el) {
      var w = el.closest('.shopify-section');
      var next = w && w.nextElementSibling;
      var p = 0;
      if (next) {
        var wr = w.getBoundingClientRect();
        var visBottom = Math.min(vh, wr.bottom);
        var visH = visBottom - Math.max(0, wr.top);
        var covered = visBottom - next.getBoundingClientRect().top;
        if (visH > 0 && covered > 0) p = clamp(covered / visH, 0, 1);
      }
      el.style.setProperty('--p', p.toFixed(3));
    });

    $$('[data-ghost-section]').forEach(function (sec) {
      var r = sec.getBoundingClientRect();
      if (r.bottom < 0 || r.top > vh) return;
      sec.style.setProperty('--gx', (((r.top + r.height / 2 - vh / 2) / vh) * -220).toFixed(1));
    });

    $$('[data-parallax]').forEach(function (el) {
      var r = el.getBoundingClientRect();
      if (r.bottom < -200 || r.top > vh + 200) return;
      var f = parseFloat(el.getAttribute('data-parallax')) || 0;
      el.style.setProperty('--py', ((r.top + r.height / 2 - vh / 2) * f).toFixed(1));
    });

    $$('[data-zip]').forEach(function (z) {
      if (z.getAttribute('data-held')) return;
      var r = z.getBoundingClientRect();
      if (r.bottom < 0 || r.top > vh + 100) return;
      z.style.setProperty('--z', clamp((vh - r.top) / (vh * 0.85), 0, 1).toFixed(3));
    });

    if (pdp) {
      if (shots.length && wide()) {
        var top = 92;
        shots.forEach(function (s, i) {
          var nx = shots[i + 1], p = 0;
          if (nx) {
            var h = s.offsetHeight, nt = nx.getBoundingClientRect().top;
            p = clamp((top + h - nt) / h, 0, 1);
          }
          s.style.setProperty('--s', p.toFixed(3));
        });
      }
      if (buyRow && buybar) {
        var br = buyRow.getBoundingClientRect();
        var on = br.bottom < 0 && !wide();
        buybar.classList.toggle('is-on', on);
        buybar.setAttribute('aria-hidden', on ? 'false' : 'true');
        $$('button', buybar).forEach(function (b) { b.tabIndex = on ? 0 : -1; });
      }
    }
  }
  function onScroll() { if (!ticking) { ticking = true; window.requestAnimationFrame(update); } }
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', function () { fixStacks(); onScroll(); });
  window.addEventListener('load', function () { fixStacks(); onScroll(); });
  if ('ResizeObserver' in window) {
    var ro = new ResizeObserver(fixStacks);
    $$('.shopify-section').forEach(function (w) { ro.observe(w); });
  }

  /* ---------- pointer effects: cursor follower, magnetic buttons, tilting cards ---------- */
  if (fine && !reduce) {
    var cur = document.createElement('div');
    cur.className = 'cursor';
    cur.setAttribute('aria-hidden', 'true');
    cur.innerHTML = '<div class="cursor-ring"><span></span></div>';
    document.body.appendChild(cur);
    var label = cur.querySelector('span');
    var mx = -100, my = -100, cx = -100, cy = -100, raf = 0, curLabel = '';
    var loop = function () {
      cx += (mx - cx) * 0.22; cy += (my - cy) * 0.22;
      cur.style.transform = 'translate3d(' + cx.toFixed(1) + 'px,' + cy.toFixed(1) + 'px,0)';
      if (Math.abs(mx - cx) > 0.3 || Math.abs(my - cy) > 0.3) raf = window.requestAnimationFrame(loop); else raf = 0;
    };
    var magnet = null, tiltEl = null;
    var release = function (el) { if (el) { el.style.translate = ''; } };
    var untilt = function (m) { if (m) { m.style.setProperty('--rx', '0deg'); m.style.setProperty('--ry', '0deg'); } };
    document.addEventListener('pointermove', function (e) {
      if (e.pointerType && e.pointerType !== 'mouse') return;
      mx = e.clientX; my = e.clientY;
      cur.classList.add('is-on');
      if (!raf) raf = window.requestAnimationFrame(loop);
      var t = e.target.closest ? e.target : null;
      var cz = t && t.closest('[data-cursor]');
      var txt = cz && !t.closest('a.btn, button, input, select, summary, .wish') ? cz.getAttribute('data-cursor') : '';
      if (txt !== curLabel) { curLabel = txt; label.textContent = txt; cur.classList.toggle('has-label', !!txt); }

      var b = t && t.closest('.btn:not([disabled])');
      if (b !== magnet) { release(magnet); magnet = b; }
      if (b) {
        var r = b.getBoundingClientRect();
        var dx = (e.clientX - (r.left + r.width / 2)) / r.width, dy = (e.clientY - (r.top + r.height / 2)) / r.height;
        b.style.translate = (dx * 12).toFixed(1) + 'px ' + (dy * 8).toFixed(1) + 'px';
      }
      var link = t && t.closest('.card-link');
      var media = link && $('.card-media', link);
      if (media !== tiltEl) { untilt(tiltEl); tiltEl = media; }
      if (media) {
        var mr = media.getBoundingClientRect();
        var px = (e.clientX - mr.left) / mr.width - 0.5, py = (e.clientY - mr.top) / mr.height - 0.5;
        media.style.setProperty('--ry', (px * 12).toFixed(1) + 'deg');
        media.style.setProperty('--rx', (py * -12).toFixed(1) + 'deg');
      }
    }, { passive: true });
    document.addEventListener('pointerdown', function () { cur.classList.add('is-down'); });
    document.addEventListener('pointerup', function () { cur.classList.remove('is-down'); });
    document.documentElement.addEventListener('mouseleave', function () { cur.classList.remove('is-on'); release(magnet); untilt(tiltEl); magnet = tiltEl = null; });
  }

  /* ---------- menu drawer ---------- */
  var lastOpener = null, closeTimer = null;
  function openDrawer(opener) {
    var d = $('[data-drawer]'); if (!d) return;
    clearTimeout(closeTimer);
    lastOpener = opener || null;
    d.hidden = false;
    document.body.classList.add('drawer-open');
    $$('[data-drawer-open]').forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
    window.requestAnimationFrame(function () { window.requestAnimationFrame(function () { d.classList.add('is-open'); }); });
    var first = $('[data-drawer-close][aria-label]', d) || $('a', d);
    if (first) first.focus();
  }
  function closeDrawer() {
    var d = $('[data-drawer]'); if (!d || d.hidden) return;
    d.classList.remove('is-open');
    document.body.classList.remove('drawer-open');
    $$('[data-drawer-open]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    closeTimer = setTimeout(function () { d.hidden = true; }, reduce ? 0 : 480);
    if (lastOpener) lastOpener.focus();
  }
  document.addEventListener('click', function (e) {
    var o = e.target.closest('[data-drawer-open]');
    if (o) { openDrawer(o); return; }
    if (e.target.closest('[data-drawer-close]')) { closeDrawer(); return; }
    var a = e.target.closest('[data-drawer] a'); if (a) closeDrawer();
  });
  document.addEventListener('keydown', function (e) {
    var d = $('[data-drawer]');
    if (!d || d.hidden) return;
    if (e.key === 'Escape') { closeDrawer(); return; }
    if (e.key === 'Tab') {
      var f = $$('a[href], button:not([disabled]), input', d).filter(function (n) { return n.offsetParent !== null; });
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });

  /* ---------- cart count ---------- */
  function setCount(n) {
    $$('[data-cart-count]').forEach(function (el) {
      el.textContent = n;
      el.classList.toggle('is-empty', !n);
      el.classList.remove('bump');
      void el.offsetWidth;
      el.classList.add('bump');
    });
  }

  /* ---------- wishlist (stored on this device only) ---------- */
  var KEY = 'tt-wishlist';
  function getW() { try { return JSON.parse(localStorage.getItem(KEY) || '[]'); } catch (e) { return []; } }
  function setW(a) { try { localStorage.setItem(KEY, JSON.stringify(a)); } catch (e) {} }
  function syncHearts() {
    var w = getW();
    $$('[data-wish]').forEach(function (b) { b.setAttribute('aria-pressed', String(w.indexOf(b.getAttribute('data-wish')) > -1)); });
  }
  function money(cents) {
    try { return new Intl.NumberFormat(document.documentElement.lang || 'en-IN', { style: 'currency', currency: R.currency, minimumFractionDigits: 0, maximumFractionDigits: 2 }).format(cents / 100); }
    catch (e) { return (cents / 100).toFixed(2); }
  }
  function renderWishlist() {
    var grid = $('[data-wishlist-grid]');
    if (!grid) return;
    var list = getW();
    var empty = $('[data-wishlist-empty]');
    grid.innerHTML = '';
    if (empty) empty.hidden = list.length > 0;
    list.forEach(function (handle) {
      fetch(R.root + 'products/' + encodeURIComponent(handle) + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { if (!r.ok) throw new Error('gone'); return r.json(); })
        .then(function (p) {
          var li = document.createElement('li');
          var a = document.createElement('a');
          a.className = 'card-link'; a.href = p.url;
          var media = document.createElement('div'); media.className = 'card-media';
          if (p.featured_image) { var img = document.createElement('img'); img.src = p.featured_image; img.alt = p.title; img.loading = 'lazy'; media.appendChild(img); }
          if (!p.available) { var s = document.createElement('span'); s.className = 'badge-sold'; s.textContent = 'SOLD'; media.appendChild(s); }
          var t = document.createElement('h3'); t.className = 'card-title'; t.textContent = p.title;
          var pr = document.createElement('p'); pr.className = 'card-price'; pr.textContent = money(p.price);
          a.appendChild(media); a.appendChild(t); a.appendChild(pr);
          var rm = document.createElement('button'); rm.type = 'button'; rm.className = 'btn btn-line'; rm.textContent = 'Remove'; rm.setAttribute('data-wish', handle); rm.setAttribute('aria-pressed', 'true');
          li.appendChild(a); li.appendChild(rm); grid.appendChild(li);
        })
        .catch(function () { setW(getW().filter(function (h) { return h !== handle; })); });
    });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-wish]');
    if (!b) return;
    e.preventDefault();
    var h = b.getAttribute('data-wish');
    var w = getW();
    var i = w.indexOf(h);
    if (i > -1) w.splice(i, 1); else w.push(h);
    setW(w); syncHearts();
    if (i < 0) { burstAt(b, 'heart', 7); buzz(14); }
    if (b.closest('[data-wishlist-grid]')) renderWishlist();
  });

  /* ---------- collection filters and cart form ---------- */
  var ff = $('[data-filter-form]');
  if (ff) ff.addEventListener('change', function () { ff.submit(); });
  var cf = $('[data-cart-form]');
  if (cf) cf.addEventListener('change', function (e) { if (e.target.matches('input[name="updates[]"]')) cf.submit(); });

  /* ---------- product page ---------- */
  function fly(fromEl) {
    if (reduce || !fromEl || !fromEl.animate) return;
    var cart = $$('[data-cart-count]')[0];
    cart = cart && (cart.closest('a') || cart);
    if (!cart) return;
    var a = fromEl.getBoundingClientRect(), b = cart.getBoundingClientRect();
    if (!a.width || !b.width) return;
    var clone = document.createElement('div');
    clone.className = 'fly';
    var img = fromEl.querySelector('img');
    if (img) { var im = document.createElement('img'); im.src = img.currentSrc || img.src; im.alt = ''; clone.appendChild(im); }
    var w0 = Math.min(a.width, 220), h0 = w0 * 1.25;
    clone.style.cssText += 'left:' + (a.left + a.width / 2 - w0 / 2) + 'px;top:' + (a.top + Math.min(a.height / 2, 200) - h0 / 2) + 'px;width:' + w0 + 'px;height:' + h0 + 'px;';
    document.body.appendChild(clone);
    var dx = b.left + b.width / 2 - (a.left + a.width / 2), dy = b.top + b.height / 2 - (a.top + Math.min(a.height / 2, 200));
    var anim = clone.animate([
      { transform: 'translate(0,0) scale(1) rotate(0deg)', opacity: 1 },
      { transform: 'translate(' + dx * 0.5 + 'px,' + (dy * 0.5 - 90) + 'px) scale(.55) rotate(-8deg)', opacity: 1, offset: 0.55 },
      { transform: 'translate(' + dx + 'px,' + dy + 'px) scale(.06) rotate(12deg)', opacity: 0.4 }
    ], { duration: 850, easing: 'cubic-bezier(.5,0,.3,1)' });
    anim.onfinish = function () { clone.remove(); };
  }

  function initProduct() {
    pdp = $('[data-product]');
    if (!pdp) return;
    var data = JSON.parse($('[data-product-json]').textContent);
    var form = $('[data-product-form]', pdp);
    var idInput = $('[data-variant-id]', pdp);
    var addBtn = $('[data-add]', pdp);
    var buyBtn = $('[data-buy]', pdp);
    var msg = $('[data-msg]', pdp);
    var barAdd = $('[data-bar-add]');
    shots = $$('[data-shot]', pdp);
    buyRow = $('[data-buy-row]', pdp);
    buybar = $('[data-buybar]');
    progress = $('[data-progress]');
    countEl = $('[data-count]', pdp);
    var track = $('[data-shots]', pdp);
    var shotIndex = 0;

    /* Fake live stats: new random numbers on every page open, not real data */
    var bagN = 1 + Math.floor(Math.random() * 50);
    var viewN = 1000 + Math.floor(Math.random() * 2001);
    var statEls = { bag: $$('[data-stat="bag"]', pdp), views: $$('[data-stat="views"]', pdp) };
    var fmt = function (n) { return n.toLocaleString('en-IN'); };
    var paint = function (key, n) { statEls[key].forEach(function (el) { el.textContent = fmt(n); }); };
    if (!reduce) {
      var t0 = performance.now();
      var run = function (now) {
        var k = Math.min(1, (now - t0) / 1100), e = 1 - Math.pow(1 - k, 3);
        paint('bag', Math.max(1, Math.round(bagN * e)));
        paint('views', Math.round(viewN * e));
        if (k < 1) requestAnimationFrame(run);
      };
      requestAnimationFrame(run);
    } else { paint('bag', bagN); paint('views', viewN); }

    var sizeTile = $('[data-size-tile]', pdp);
    if (sizeTile) {
      pdp.addEventListener('change', function (e) {
        var t = e.target;
        if (!t || t.type !== 'radio') return;
        var lg = t.closest('fieldset') && t.closest('fieldset').querySelector('legend');
        if (lg && /size/i.test(lg.textContent)) sizeTile.textContent = t.value;
      });
    }

    if (track) {
      var coverflow = function () {
        if (wide()) return;
        var first = shots[0]; if (!first) return;
        var mid = track.scrollLeft + track.clientWidth / 2;
        shots.forEach(function (sh) {
          var c = sh.offsetLeft + sh.offsetWidth / 2;
          var d = (c - mid) / (sh.offsetWidth + 14);
          sh.style.setProperty('--c', clamp(Math.abs(d), 0, 1.2).toFixed(3));
          sh.style.setProperty('--dir', d < 0 ? -1 : 1);
        });
        if (countEl) {
          var i = clamp(Math.round(track.scrollLeft / (first.offsetWidth + 14)), 0, shots.length - 1);
          countEl.textContent = (i + 1) + ' / ' + shots.length;
        }
      };
      track.addEventListener('scroll', coverflow, { passive: true });
      window.addEventListener('resize', coverflow);
      coverflow();
    }

    // measurements count up when opened
    $$('[data-meas]', pdp).forEach(function (d) {
      var prepared = false;
      d.addEventListener('toggle', function () {
        if (!d.open) return;
        $$('.meas li', d).forEach(function (li) {
          if (!prepared) {
            var m = li.textContent.match(/^(.*?)(\d+(?:[.,]\d+)?)(.*)$/);
            if (m) {
              li.textContent = '';
              var a = document.createElement('span'); a.textContent = m[1].replace(/[:\-]\s*$/, '').trim();
              var n = document.createElement('span'); n.className = 'num'; n.setAttribute('data-to', m[2].replace(',', '.'));
              var u = document.createElement('span'); u.textContent = m[3].trim();
              li.appendChild(a); li.appendChild(document.createTextNode(' ')); li.appendChild(n); li.appendChild(document.createTextNode(' ')); li.appendChild(u);
            }
          }
        });
        prepared = true;
        $$('.num', d).forEach(function (n) {
          var to = parseFloat(n.getAttribute('data-to')), dec = (n.getAttribute('data-to').split('.')[1] || '').length;
          if (reduce) { n.textContent = to.toFixed(dec); return; }
          var t0 = null;
          var step = function (t) {
            if (t0 === null) t0 = t;
            var k = clamp((t - t0) / 800, 0, 1), e = 1 - Math.pow(1 - k, 3);
            n.textContent = (to * e).toFixed(dec);
            if (k < 1) window.requestAnimationFrame(step);
          };
          window.requestAnimationFrame(step);
        });
      });
    });

    var show = function (mediaId) {
      if (!mediaId) return;
      var idx = -1;
      shots.forEach(function (s, i) { if (s.getAttribute('data-slide') === String(mediaId)) idx = i; });
      if (idx < 0 || idx === shotIndex) return;
      shotIndex = idx;
      var s = shots[idx];
      var beh = reduce ? 'auto' : 'smooth';
      if (wide()) {
        var base = track.getBoundingClientRect().top + (window.pageYOffset || 0);
        window.scrollTo({ top: Math.max(0, base + idx * (s.offsetHeight + 30) - 92), behavior: beh });
      } else {
        track.scrollTo({ left: s.offsetLeft - (track.clientWidth - s.offsetWidth) / 2, behavior: beh });
      }
    };

    var current = function () {
      var sel = $$('[data-option-index]:checked', pdp).map(function (i) { return i.value; });
      if (!sel.length) return data.variants[0];
      for (var i = 0; i < data.variants.length; i++) {
        var v = data.variants[i], ok = true;
        for (var j = 0; j < sel.length; j++) if (v.options[j] !== sel[j]) { ok = false; break; }
        if (ok) return v;
      }
      return null;
    };
    var setBars = function (label, disabled) {
      addBtn.textContent = label; addBtn.disabled = disabled; buyBtn.disabled = disabled;
      if (barAdd) { barAdd.textContent = label; barAdd.disabled = disabled; }
    };
    var render = function (v) {
      var price = $('[data-price]', pdp), cmp = $('[data-compare]', pdp), off = $('[data-off]', pdp), one = $('[data-one]', pdp);
      var barPrice = $('[data-bar-price]');
      if (!v) { setBars('Unavailable', true); one.hidden = true; return; }
      idInput.value = v.id;
      if (price.textContent !== v.price) {
        price.textContent = v.price;
        price.classList.remove('flip'); void price.offsetWidth; price.classList.add('flip');
        var tp = $('[data-tag-price]', pdp); if (tp) tp.textContent = v.price;
        buzz(8);
      }
      if (barPrice) barPrice.textContent = v.price;
      cmp.hidden = off.hidden = !v.compare;
      if (v.compare) { cmp.textContent = v.compare; off.textContent = v.off + '% off'; }
      one.hidden = !v.one;
      setBars(v.available ? 'Add to bag' : 'Sold', !v.available);
      show(v.media);
      if (history.replaceState) history.replaceState(null, '', pdp.getAttribute('data-product-url') + '?variant=' + v.id);
    };
    $$('[data-option-index]', pdp).forEach(function (i) { i.addEventListener('change', function () { render(current()); }); });

    var submit = function () {
      setBars(addBtn.textContent, true);
      msg.textContent = '';
      var source = shots[Math.min(shotIndex, shots.length - 1)] || pdp;
      fetch(R.cartAdd + '.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
        .then(function (res) {
          if (res.ok) {
            msg.textContent = 'Added to your bag.';
            msg.classList.remove('pop'); void msg.offsetWidth; msg.classList.add('pop');
            fly(source);
            burstAt(addBtn, 'confetti', 18);
            buzz([18, 40, 18]);
            addBtn.classList.add('is-done'); setTimeout(function () { addBtn.classList.remove('is-done'); }, 1400);
            if (buybar) { buybar.classList.remove('bounce'); void buybar.offsetWidth; buybar.classList.add('bounce'); }
            return fetch(R.cart + '.js').then(function (r) { return r.json(); }).then(function (c) { setTimeout(function () { setCount(c.item_count); }, reduce ? 0 : 800); });
          }
          msg.textContent = res.j.description || res.j.message || 'This piece could not be added.';
        })
        .catch(function () { msg.textContent = 'Something went wrong. Try again.'; })
        .then(function () { var v = current(); setBars(v && v.available ? 'Add to bag' : 'Sold', !(v && v.available)); });
    };
    form.addEventListener('submit', function (e) {
      if (e.submitter && e.submitter.name === 'checkout') return;
      e.preventDefault();
      submit();
    });
    if (barAdd) barAdd.addEventListener('click', function () { if (!barAdd.disabled) submit(); });

    var lb = $('[data-lightbox]');
    if (lb && lb.showModal) {
      var lastTap = 0, tapTimer = null;
      pdp.addEventListener('click', function (e) {
        var z = e.target.closest('[data-zoom]');
        if (!z) return;
        var open = function () { $('[data-lightbox-img]', lb).src = z.getAttribute('data-large'); lb.showModal(); };
        if (!coarse) { open(); return; }
        // phones: a double tap saves the piece, a single tap zooms
        var now = Date.now();
        clearTimeout(tapTimer);
        if (now - lastTap < 320) {
          lastTap = 0;
          var w = getW(), h = pdp.getAttribute('data-product-url').split('/').pop().split('?')[0];
          if (w.indexOf(h) < 0) { w.push(h); setW(w); syncHearts(); }
          burst(e.clientX, e.clientY, 'heart', 9); buzz(20);
          return;
        }
        lastTap = now;
        tapTimer = setTimeout(open, 320);
      });
      lb.addEventListener('click', function (e) { if (e.target === lb || e.target.closest('[data-lightbox-close]')) lb.close(); });
    }
  }

  /* ---------- related products ---------- */
  var rec = $('[data-recommendations]');
  if (rec && rec.getAttribute('data-url')) {
    fetch(rec.getAttribute('data-url'))
      .then(function (r) { return r.text(); })
      .then(function (t) {
        var d = new DOMParser().parseFromString(t, 'text/html').querySelector('[data-recommendations]');
        if (d && d.innerHTML.trim()) { rec.innerHTML = d.innerHTML; syncHearts(); initReveal(rec); initRails(); }
      })
      .catch(function () {});
  }

  /* ---------- phones only: tap sparkles, draggable zipper, long-press to save ---------- */
  if (coarse && !reduce) {
    var lastSpark = 0;
    document.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'mouse') return;
      if (e.target.closest && e.target.closest('input, textarea, select, .zip-pull')) return;
      var now = Date.now();
      if (now - lastSpark < 120) return;
      lastSpark = now;
      burst(e.clientX, e.clientY, 'spark', 5);
    }, { passive: true });

    // pull the zipper tab with a thumb
    var held = null, hz = null;
    var setZ = function (e) {
      var r = held.getBoundingClientRect();
      var z = clamp((e.clientX - r.left - 30) / Math.max(1, r.width - 60), 0, 1);
      if ((z === 0 || z === 1) && hz !== z) buzz(14);
      hz = z;
      held.style.setProperty('--z', z.toFixed(3));
    };
    document.addEventListener('pointerdown', function (e) {
      var p = e.target.closest && e.target.closest('.zip-pull');
      if (!p) return;
      held = p.closest('[data-zip]');
      held.setAttribute('data-held', '1');
      try { p.setPointerCapture(e.pointerId); } catch (err) {}
      buzz(8); setZ(e);
    });
    document.addEventListener('pointermove', function (e) { if (held) setZ(e); });
    var drop = function () { if (held) { held.removeAttribute('data-held'); held = null; hz = null; onScroll(); } };
    document.addEventListener('pointerup', drop);
    document.addEventListener('pointercancel', drop);

    // press and hold a card to save it
    var pressTimer = null, pressed = false, px = 0, py = 0;
    document.addEventListener('pointerdown', function (e) {
      var link = e.target.closest && e.target.closest('.card-link');
      if (!link) return;
      px = e.clientX; py = e.clientY;
      var card = link.closest('.card'), btn = card && $('[data-wish]', card);
      clearTimeout(pressTimer);
      pressTimer = setTimeout(function () {
        if (!btn) return;
        pressed = true;
        if (btn.getAttribute('aria-pressed') !== 'true') btn.click(); else { burstAt(btn, 'heart', 5); buzz(12); }
        setTimeout(function () { pressed = false; }, 700);
      }, 520);
    }, { passive: true });
    document.addEventListener('pointermove', function (e) {
      if (pressTimer && (Math.abs(e.clientX - px) > 10 || Math.abs(e.clientY - py) > 10)) { clearTimeout(pressTimer); pressTimer = null; }
    }, { passive: true });
    ['pointerup', 'pointercancel'].forEach(function (n) { document.addEventListener(n, function () { clearTimeout(pressTimer); pressTimer = null; }); });
    document.addEventListener('click', function (e) {
      if (pressed && e.target.closest('.card-link')) { e.preventDefault(); e.stopPropagation(); }
    }, true);
    document.addEventListener('contextmenu', function (e) { if (e.target.closest && e.target.closest('.card-link, .shot')) e.preventDefault(); });
    // size chips and bag buttons buzz a little
    document.addEventListener('change', function (e) { if (e.target.matches && e.target.matches('[data-option-index]')) buzz(8); });
  }

  /* ---------- back to top ---------- */
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-top]')) window.scrollTo({ top: 0, behavior: reduce ? 'auto' : 'smooth' });
  });

  /* ---------- start, and re-run when the theme editor reloads a section ---------- */
  function init() { initReveal(); setupStacks(); initJiggle(); initRails(); initMarquee(); syncHearts(); renderWishlist(); update(); }
  document.addEventListener('shopify:section:load', init);
  init();
  initProduct();
  update();
})();
